export default __webpack_public_path__ + "static/media/hami_nepal.c4526f4f.png";